import React,{useEffect,useState,useRef} from "react";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent,DialogUtility } from '@syncfusion/ej2-react-popups';

import { Header } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import validator from "validator";


const Logs = () => {
  const { currentMode } = useStateContext();
  const bgcolor = currentMode === "Dark" ? "bg-gray-700" : "bg-white";
  const [period, setPeriod] = useState("");

    return(
      <div className={"md:mx-5 p-2 md:rounded-2xl " + bgcolor} >
      <Header title="Logs" /> 
      <div>
        {/* Filter Module */}
        <form
          style={{ display: "flex", gap: "1rem", flexWrap: "wrap", alignItems: "center" }}
          onSubmit={e => {
            e.preventDefault();
            // Call your API with selected filters here
          }}
        >
          {/* Week/Month Selector */}
          <select
            name="period"
            value={period}
            onChange={e => setPeriod(e.target.value)}
          >
            <option value="">Select Period</option>
            <option value="week">This Week</option>
            <option value="month">This Month</option>
            <option value="custom">Custom Range</option>
          </select>

          {/* Date Range - only show for custom */}
          {period === "custom" && (
            <>
              <label>
                From:
                <input type="date" name="fromDate" />
              </label>
              <label>
                To:
                <input type="date" name="toDate" />
              </label>
            </>
          )}

          {/* Time Range - always show */}
          <label>
            Start Time:
            <input type="time" name="startTime" />
          </label>
          <label>
            End Time:
            <input type="time" name="endTime" />
          </label>

          {/* Item Type */}
          <select name="itemType">
            <option value="">All Items</option>
            <option value="breakfast">Breakfast</option>
            <option value="lunch">Lunch</option>
            {/* Add more types as needed */}
          </select>

          <button type="submit">Filter</button>
        </form>
      </div>
      <div>
        {/* results will show up as  grid or carts */}
      </div>
    </div>
    )
  }
  
  export default Logs;
  